import { toast } from "sonner";
import { Dice6 } from "lucide-react";

export const abilityMod = (score) => {
  const s = parseInt(score, 10);
  if (Number.isNaN(s)) return 0;
  return Math.floor((s - 10) / 2);
};

export const formatMod = (n) => (n >= 0 ? `+${n}` : String(n));

export const proficiencyBonus = (level) => {
  const lv = parseInt(level, 10) || 1;
  return Math.ceil(lv / 4) + 1;
};

/**
 * Roll d20 with optional modifier and label, then toast the result.
 * Returns the total so callers can chain.
 */
export const rollD20 = (modifier = 0, label = "Check", opts = {}) => {
  const die = Math.floor(Math.random() * 20) + 1;
  const total = die + modifier;
  const crit = die === 20;
  const fumble = die === 1;
  const modStr = modifier === 0 ? "" : (modifier > 0 ? ` + ${modifier}` : ` − ${Math.abs(modifier)}`);
  toast.message(
    <span className="font-medium flex items-center gap-2">
      <Dice6 className="w-4 h-4 text-primary" />
      <span className="font-serif">{label}:</span>
      <span className="text-foreground font-bold">{total}</span>
      <span className="text-muted-foreground text-xs">({die}{modStr})</span>
      {crit && <span className="text-amber-400 text-xs font-bold ml-1">CRIT!</span>}
      {fumble && <span className="text-red-500 text-xs font-bold ml-1">FUMBLE</span>}
    </span>,
    { duration: 3500 }
  );
  opts.onRoll?.({ die, total, crit, fumble, modifier, label });
  return total;
};

export const rollDice = (notation, label = "Roll") => {
  // tiny parser: NdM[+|-]K
  const m = /^(\d+)d(\d+)([+-]\d+)?$/.exec(notation.replace(/\s+/g, ""));
  if (!m) return rollD20(0, label);
  const n = +m[1], faces = +m[2], mod = m[3] ? +m[3] : 0;
  let sum = 0; const rolls = [];
  for (let i = 0; i < n; i++) { const r = Math.floor(Math.random() * faces) + 1; rolls.push(r); sum += r; }
  const total = sum + mod;
  toast.message(
    <span className="font-medium flex items-center gap-2">
      <Dice6 className="w-4 h-4 text-primary" />
      <span className="font-serif">{label}:</span>
      <span className="text-foreground font-bold">{total}</span>
      <span className="text-muted-foreground text-xs">({notation}: [{rolls.join(", ")}]{mod ? `, ${mod >= 0 ? "+" : ""}${mod}` : ""})</span>
    </span>,
    { duration: 3500 }
  );
  return total;
};
